import {
  GET_CHITIET_HOPDONG,
  GET_CHITIET_HOPDONG_SUCCESS,
  GET_CHITIET_HOPDONG_FAILURE,
  GET_LICH_SU_HOP_DONG,
  GET_LICH_SU_HOP_DONG_SUCCESS,
  GET_LICH_SU_HOP_DONG_FAILURE,
  GET_LICH_SU_VT_TB,
  GET_LICH_SU_VT_TB_SUCCESS,
  GET_LICH_SU_VT_TB_FAILURE,
  GET_LIST_TAI_SAN_CAM_CO,
  GET_LIST_TAI_SAN_CAM_CO_SUCCESS,
  GET_LIST_TAI_SAN_CAM_CO_FAILURE,
  GET_LICH_SU_NO_PHAI_THU,
  GET_LICH_SU_NO_PHAI_THU_SUCCESS,
  GET_LICH_SU_NO_PHAI_THU_FAILURE,
  GET_LIST_GHI_CHU,
  GET_LIST_GHI_CHU_SUCCESS,
  GET_LIST_GHI_CHU_FAILURE,
} from "actions/ChiTietHopDong/actionTypes";

const initialState = {
  getChiTietHopDongLoading: false,
  objChiTietHopDong: {},
  objLichSuHopDong: {
    TotalRows: 0,
    List: [],
    TotalSoTien: 0,
  },
  objLichSuVTTB: {
    TotalRows: 0,
    List: [],
    TongTienVayThemTraBotGoc: 0,
  },
  objListCamCo: {
    TotalRows: "1",
    CamDoTongPhiKho: 0.0,
    List: [],
  },
  objLichSuNoPhaiThu: {
    TotalRows: 0,
    List: [],
    TotalValue: 0,
  },
  objListGhiChu: {
    TotalRows: 0,
    List: [],
  },
};

const getChiTietHopDong = (state, action) => ({
  ...state,
  getChiTietHopDongLoading: true,
});

const getChiTietHopDongSuccess = (state, action) => {
  return {
    ...state,
    getChiTietHopDongLoading: false,
    objChiTietHopDong: action.payload,
  };
};

const getChiTietHopDongFailed = (state, action) => ({
  ...state,
  getChiTietHopDongLoading: false,
  objChiTietHopDong: {},
});

const getLichSuHopDong = (state, action) => ({
  ...state,
});

const getLichSuHopDongSuccess = (state, action) => {
  return {
    ...state,
    objLichSuHopDong: action.payload,
  };
};

const getLichSuHopDongFailed = (state, action) => ({
  ...state,
  objLichSuHopDong: {
    TotalRows: 0,
    List: [],
  },
});

const getLichSuVayThemTraBotGoc = (state, action) => ({
  ...state,
});

const getLichSuVayThemTraBotGocSuccess = (state, action) => {
  return {
    ...state,
    objLichSuVTTB: action.payload,
  };
};

const getLichSuVayThemTraBotGocFailed = (state, action) => ({
  ...state,
  objLichSuVTTB: {
    TotalRows: 0,
    List: [],
    TongTienVayThemTraBotGoc: 0,
  },
});
const getListTaiSanCamCo = (state) => ({
  ...state,
});

const getListTaiSanCamCoSuccess = (state, action) => {
  return {
    ...state,
    objListCamCo: action.payload,
  };
};

const getListTaiSanCamCoFailure = (state, action) => {
  return {
    ...state,
    objListCamCo: {
      TotalRows: "1",
      CamDoTongPhiKho: 0.0,
      List: [],
    },
  };
};
const getLichSuNoPhaiThu = (state) => ({
  ...state,
});
const getLichSuNoPhaiThuSuccess = (state, action) => {
  return {
    ...state,
    objLichSuNoPhaiThu: action.payload,
  };
};
const getLichSuNoPhaiThuFailure = (state, action) => {
  return {
    ...state,
    objLichSuNoPhaiThu: {
      TotalRows: 0,
      List: [],
      TotalValue: 0,
    },
  };
};
const getListGhiChu = (state) => ({
  ...state,
});

const getListGhiChuSuccess = (state, action) => {
  return {
    ...state,
    objListGhiChu: action.payload,
  };
};

const getListGhiChuFailure = (state, action) => {
  return {
    ...state,
    objListGhiChu: {
      TotalRows: 0,
      List: [],
    },
  };
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHITIET_HOPDONG:
      return getChiTietHopDong(state, action);
    case GET_CHITIET_HOPDONG_SUCCESS:
      return getChiTietHopDongSuccess(state, action);
    case GET_CHITIET_HOPDONG_FAILURE:
      return getChiTietHopDongFailed(state, action);
    case GET_LICH_SU_HOP_DONG:
      return getLichSuHopDong(state, action);
    case GET_LICH_SU_HOP_DONG_SUCCESS:
      return getLichSuHopDongSuccess(state, action);
    case GET_LICH_SU_HOP_DONG_FAILURE:
      return getLichSuHopDongFailed(state, action);
    case GET_LICH_SU_VT_TB:
      return getLichSuVayThemTraBotGoc(state, action);
    case GET_LICH_SU_VT_TB_SUCCESS:
      return getLichSuVayThemTraBotGocSuccess(state, action);
    case GET_LICH_SU_VT_TB_FAILURE:
      return getLichSuVayThemTraBotGocFailed(state, action);
    case GET_LIST_TAI_SAN_CAM_CO:
      return getListTaiSanCamCo(state, action);
    case GET_LIST_TAI_SAN_CAM_CO_SUCCESS:
      return getListTaiSanCamCoSuccess(state, action);
    case GET_LIST_TAI_SAN_CAM_CO_FAILURE:
      return getListTaiSanCamCoFailure(state, action);
    case GET_LICH_SU_NO_PHAI_THU:
      return getLichSuNoPhaiThu(state, action);
    case GET_LICH_SU_NO_PHAI_THU_SUCCESS:
      return getLichSuNoPhaiThuSuccess(state, action);
    case GET_LICH_SU_NO_PHAI_THU_FAILURE:
      return getLichSuNoPhaiThuFailure(state, action);
    case GET_LIST_GHI_CHU:
      return getListGhiChu(state, action);
    case GET_LIST_GHI_CHU_SUCCESS:
      return getListGhiChuSuccess(state, action);
    case GET_LIST_GHI_CHU_FAILURE:
      return getListGhiChuFailure(state, action);
    default:
      return state;
  }
};

export default authReducer;
